module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('v-card', [_c('vuex-loader', {
    attrs: {
      "request-id": "saveReqId"
    }
  }), _vm._v(" "), _c('vuex-loader', {
    attrs: {
      "request-id": "reqId"
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "extended": ""
    }
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "label": ""
    }
  }, [_vm._v(_vm._s(_vm.invoice.status))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "loading": _vm.invoiceSaveRequest.loading,
      "placeholder": "Invoice title"
    },
    model: {
      value: (_vm.invoice.title),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "title", $$v)
      },
      expression: "invoice.title"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.getInvoice
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v(" "), _c('span', [_vm._v("Reload invoice data")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [(_vm.invoice.relationship_id) ? _c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.gotoRelationship(_vm.invoice.relationship_id)
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "ml-2"
  }, [_vm._v("person")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Show client")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [(_vm.invoiceUrl) ? _c('v-btn', {
    attrs: {
      "slot": "activator",
      "href": _vm.invoiceUrl,
      "target": "_blank",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "ml-2"
  }, [_vm._v("open_in_new")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Open invoice preview in a new window")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.launchSendInvoiceDialog({
          invoice: _vm.invoice,
          client: _vm.client,
          withClose: false
        })
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "ml-2"
  }, [_vm._v("send")])], 1), _vm._v(" "), _c('span', [_vm._v("Send via email or sms")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [_c('v-breadcrumbs', {
    staticClass: "ml-2",
    attrs: {
      "divider": "/"
    }
  }, [_c('v-breadcrumbs-item', {
    attrs: {
      "to": "/invoices/",
      "exact": ""
    }
  }, [_vm._v("Invoices")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("#" + _vm._s(_vm.invoice.id))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "small": "",
      "loading": _vm.invoiceSaveRequest.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          Save changes")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.invoice.compatibility === 1 && _vm.invoice && _vm.invoice.id) ? _c('v-tabs', {
    staticClass: "mb-4",
    attrs: {
      "dark": "",
      "slider-color": "yellow"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.edit')))]), _vm._v(" "), _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.statementTouch++
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tabs.statement')))]), _vm._v(" "), _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.versionTouch++
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tabs.versions')))]), _vm._v(" "), _c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.communications')))]), _vm._v(" "), _c('v-tab-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "subheading hidden-sm-and-up grey lighten-4 hidden-xs-only"
  }, [_vm._v("\n        #" + _vm._s(_vm.invoice.id) + "\n      ")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading grey lighten-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-chip', {
    staticClass: "hidden-xs-only mt-2",
    attrs: {
      "large": "",
      "label": "",
      "outline": ""
    }
  }, [_vm._v("#" + _vm._s(_vm.invoice.id))])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.invoice.encrypt_password) ? _c('v-list', {
    staticClass: "pa-0 elevation-2",
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', {
    staticClass: "mt-3",
    attrs: {
      "color": "amber"
    }
  }, [_vm._v("lock")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "overline"
  }, [_vm._v("\n                    Password protected\n                  ")]), _vm._v(" "), _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.invoice.encrypt_password)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.invoice.encrypt_password_hint)
    }
  })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showEncrypt = true
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1)], 1) : _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.showEncrypt = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("lock")]), _vm._v("\n              Add password\n            ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showEncrypt),
      callback: function($$v) {
        _vm.showEncrypt = $$v
      },
      expression: "showEncrypt"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline py-0 grey lighten-4"
  }, [(_vm.invoice.encrypt_password) ? _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "amber"
    }
  }, [_vm._v("lock")]) : _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "info"
    }
  }, [_vm._v("lock_open")]), _vm._v("\n            Manage password\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showEncrypt = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('encrypt-invoice', {
    staticClass: "mt-3",
    attrs: {
      "password": _vm.invoice.encrypt_password,
      "password-hint": _vm.invoice.encrypt_password_hint
    },
    on: {
      "update:password": function($event) {
        return _vm.$set(_vm.invoice, "encrypt_password", $event)
      },
      "update:passwordHint": function($event) {
        return _vm.$set(_vm.invoice, "encrypt_password_hint", $event)
      },
      "update:password-hint": function($event) {
        return _vm.$set(_vm.invoice, "encrypt_password_hint", $event)
      }
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showEncrypt = false
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.invoiceSaveRequest.loading
    },
    on: {
      "click": _vm.savePassword
    }
  }, [_vm._v("save")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('invoice-detail', {
    attrs: {
      "loading": _vm.invoiceSaveRequest.loading
    },
    on: {
      "save": _vm.save,
      "refresh": _vm.getInvoice
    },
    model: {
      value: (_vm.invoice),
      callback: function($$v) {
        _vm.invoice = $$v
      },
      expression: "invoice"
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('tabs.statement')) + "\n        "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_vm._v("\n        Here is a breakdown of the appointments in this invoice:\n      ")]), _vm._v(" "), _c('invoice-payments', {
    attrs: {
      "invoice": _vm.invoice,
      "transactions": _vm.invoice.transaction_set
    }
  }), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('help-popover', [_vm._v("\n          Every change you make to invoices is recorded and safely stored\n          in the cloud as a pdf. You can view all versions of this document below\n        ")]), _vm._v("\n        " + _vm._s(_vm.$t('tabs.versions')) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.versionTouch++
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.invoice && _vm.invoice.id) ? _c('invoice-versions', {
    attrs: {
      "touch": _vm.versionTouch,
      "invoice": _vm.invoice
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('tabs.communications')) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.invoiceCommsRequest.loading,
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.commsTouch++
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), (_vm.invoice && _vm.invoice.id) ? _c('invoice-communications', {
    attrs: {
      "touch": _vm.commsTouch,
      "req-id": _vm.commsreqid,
      "invoice-id": _vm.invoice.id
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12c697b3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Invoice.vue
// module id = 1331
// module chunks = 9